<div class="contact-field" [class.disabled-section]="!isEnabled">
    <ng-container *ngTemplateOutlet="contactState; context: { $implicit: contactStates[0] }"></ng-container>

    <mat-icon class="swap" [class.focus]="isShowSelect" svgIcon="swap" (click)="onSwapStatus.emit()"></mat-icon>

    <ng-container *ngTemplateOutlet="contactState; context: { $implicit: contactStates[1] }"></ng-container>
</div>

<ng-template #contactState let-contact>
    <div class="contact-state">
        <label>{{ contact.labelKey | translate }}</label>

        <input
            *ngIf="statusSetting === StatusSetting.CUSTOM; else contactText"
            [ngClass]="{
                'custom-contact-input': true,
                'custom-contact-input-error': isTouched(contact.key) && !digitalAlarmSetting[contact.key],
            }"
            [(ngModel)]="digitalAlarmSetting[contact.key]"
            (ngModelChange)="onChange.emit()"
            (blur)="onBlur(contact.key)"
            [attr.placeholder]="contact.placeholderKey | translate"
            [attr.maxlength]="CONTACT_STATUS_MAX_LENGTH" />

        <span
            *ngIf="
                statusSetting === StatusSetting.CUSTOM && isTouched(contact.key) && !digitalAlarmSetting[contact.key]
            "
            class="validation-message">
            {{ 'input.text.errors.REQUIRED' | translate }}
        </span>

        <ng-template #contactText>
            <span class="state">
                {{ digitalAlarmSetting?.[contact.key] }}
            </span>
        </ng-template>
    </div>
</ng-template>
